<template>
  <section
    id="dates-and-prices"
    class="datesprices section"
  >
    <div class="container">
      <div class="level dates-prices-header main-header is-vcentered">
        <div class="dates-prices-header__title">
          <h2 class="header">
            {{ model.labels.dateRatesTitle }}
          </h2>
          <div
            class="dates-prices-results-count"
            :class="{ disabled: localappdata.apiError }"
          >
            Results:
            <span v-if="!localappdata.dataAll.length && !localappdata.apiError">loading...</span>
            <span v-if="localappdata.dataAll.length">{{ localappdata.visibleList.length }} / {{ localappdata.dataAll.length }}</span>
            <span v-if="localappdata.apiError">0</span>
          </div>
        </div>
        <div class="level-right">
          <div
            v-if="localappdata.dataAll.length !== localappdata.dataOnlyAvailableTotal"
            class="level-item available-toggle dates-prices-toggle dates-prices-header__item is-3-tablet"
          >
            <dates-prices-filter-available
              :model="model"
              :raqmodel="raqmodel"
              @update-only-available-flag="updateShowAllDataFlag($event)"
            />
          </div>
          <div class="level-item dates-prices-filters">
            <dates-prices-filter-months
              :model="model"
              :months="localappdata.availableMonths"
              :apierror="localappdata.apiError"
              :selectedmonths="localappdata.userActions.selectedMonths"
              @update-selected-months-array="updateSelectedMonths($event)"
            />
            <dates-prices-filter-ships
              :model="model"
              :ships="localappdata.availableShips"
              :shipsmatch="localappdata.allShipsMatch"
              :apierror="localappdata.apiError"
              :selectedship="localappdata.userActions.selectedShip"
              @update-selected-ship="updateSelectedShip($event)"
            />
            <div
              v-if="directions?.directions?.length > 0"
              class="dropdown"
            >
              <div class="dropdown-trigger">
                <button
                  class="button"
                  :class="{
                    'filters-active': true,
                    'no-dropdown': directions.directions.length === 1
                  }"
                >
                  <span v-if="directions.directions.length === 1">{{
                    directions.directions[0].name
                  }}</span>
                  <span v-if="directions.directions.length > 1">{{
                    directions.directions[selectedDirectionId - 1].name
                  }}</span>
                  <span
                    v-if="directions.directions.length > 1"
                    class="icon is-small"
                  >
                    <i
                      class="fas fa-angle-down"
                      aria-hidden="true"
                    />
                  </span>
                </button>
              </div>
              <ul
                v-if="directions.directions.length > 1"
                class="dropdown-menu dropdown-content"
              >
                <li
                  v-for="(direction, index) in directions.directions"
                  :key="index"
                  class="dropdown-item is-paddingless is-flex"
                  :class="selectedDirectionId === index + 1 ? 'selected' : ''"
                >
                  <label
                    class="dropdown-label"
                    :for="'direction-' + index"
                  >
                    <input
                      :id="'direction-' + index"
                      type="radio"
                      :value="index + 1"
                      :checked="selectedDirectionId === index + 1"
                      @change="changeDirection(direction.name, index + 1)"
                    >
                    {{ direction.name }}
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dates-prices-item-container is-relative">
      <ships-dates-prices-row
        v-for="item in localappdata.visibleList"
        :key="item.index"
        :model="model"
        :row="item"
        :raqmodel="raqmodel"
        :tel-number="telNumber"
        :localappdata="localappdata"
        :regional-settings="regionalSettings"
        :modal-settings="modalSettings"
        :call-now-modal="callNowModal"
        @update-current-modal-content="updateCurrentDealsHtml($event)"
      />
      <div
        v-if="localappdata.isLoadingFresh"
        class="dates-prices-item-loader"
      >
        <div
          v-if="!localappdata.apiError"
          class="loader-bar inverse"
        />
        <h3
          v-if="localappdata.apiError"
          class="has-text-centered has-text-white"
        >
          <br>Trips are unable to load at the moment, please refresh the page or try again later.
        </h3>
      </div>
    </div>
    <div
      v-if="!localappdata.isLoadingFresh && !localappdata.visibleList.length"
      class="has-text-centered datesprices-noresults-holder"
    >
      <h3 v-if="localappdata.dataAll.length !== localappdata.dataOnlyAvailableTotal">
        No results. Try switching the 'Available only' toggle
      </h3>
      <h3 v-if="localappdata.dataAll.length == localappdata.dataOnlyAvailableTotal">
        No results. Try removing some filters
      </h3>
    </div>
    <div
      id="currentDealsModal"
      class="modal current-deals-modal wide-modal"
      :class="modalIsActive ? 'is-active' : ''"
    >
      <div class="modal-background" />
      <div class="modal-card">
        <div class="modal-form">
          <div class="modal-card-head">
            <p class="modal-card-title is-size-6">
              Current Deals
            </p>
            <div
              class="modal-card-close"
              @click.prevent="closeDealsModal()"
            >
              <i class="fa fa-times fa-lg" />
            </div>
          </div>
          <form>
            <section class="modal-card-body">
              <div
                class="modal-card-content current-deals-modal-content has-text-black is-size-6"
                v-html="currentModalContent"
              />
            </section>
          </form>
        </div>
      </div>
    </div>
    <div />
    <call-now-modal />
  </section>
</template>

<script>
import ShipsDatesPricesRow from './ships-dates-prices-row.vue';
import DatesPricesFilterAvailable from './dates-prices-filters/dates-prices-filter-available.vue';
import DatesPricesFilterMonths from './dates-prices-filters/dates-prices-filter-months.vue';
import DatesPricesFilterShips from './dates-prices-filters/dates-prices-filter-ships.vue';
import CallNowModal from '../modals/call-now-modal.vue';
import { closeModal } from '../../modals/closeModal';
import EventBus from '../../vue-functions/event-bus';

export default {
  components: {
    'ships-dates-prices-row': ShipsDatesPricesRow,
    'dates-prices-filter-available': DatesPricesFilterAvailable,
    'dates-prices-filter-months': DatesPricesFilterMonths,
    'dates-prices-filter-ships': DatesPricesFilterShips,
    'call-now-modal': CallNowModal
  },
  props: [
    'model',
    'raqmodel',
    'localappdata',
    'regionalSettings',
    'directions',
    'modalSettings',
    'callNowModal'
  ],
  data() {
    return {
      telNumber: 0,
      currentModalContent: '',
      modalIsActive: false,
      selectedDirectionId: 1,
      storedDataAll: []
    };
  },
  watch: {
    'localappdata.dataAll': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.storedDataAll = [...newVal];

          // filter the data when loading is complete
          if (!this.localappdata.isLoadingMore) {
            this.filterAndDisplayData();
          }
        }
      },
      deep: true
    },
    'localappdata.isLoadingMore': {
      handler(newVal) {
        if (newVal === false && this.storedDataAll.length > 0) {
          this.filterAndDisplayData();
        }
      }
    }
  },
  created() {
    this.getTelNumber();

    // initialize with first direction if available
    if (this.directions?.directions?.length > 0) {
      this.selectedDirectionId = 1;
      const initialDirection = this.directions.directions[0];
      // Emit event to notify other components
      EventBus.$emit('DIRECTION_CHANGED', initialDirection.name, 1);
    }

    EventBus.$on('DIRECTION_CHANGED', (_directionName, directionId) => {
      this.selectedDirectionId = directionId;
      if (this.storedDataAll.length > 0) {
        this.filterAndDisplayData();
      } else {
        this.populateVisibleList();
      }
    });

    this.populateVisibleList();
  },
  mounted() {
    this.toggleDropdownFilters();
    this.closeModal(this.closeDealsModal);
  },
  methods: {
    showmoreclicked: function (showAllDataFlag) {
      this.$emit('showmoreclicked', showAllDataFlag);
    },
    changeDirection(directionName, directionId) {
      this.selectedDirectionId = directionId;
      EventBus.$emit('DIRECTION_CHANGED', directionName, directionId);
      if (this.storedDataAll.length > 0) {
        this.filterAndDisplayData();
      } else {
        this.populateVisibleList();
      }
    },
    getTelNumber() {
      this.telNumber = document.querySelector('.notificationbar__utils__text').href;
    },
    closeDealsModal() {
      this.modalIsActive = false;
    },
    updateCurrentDealsHtml(updatedCurrentDeals) {
      this.currentModalContent = updatedCurrentDeals;
      this.modalIsActive = true;
    },
    updateShowAllDataFlag(updatedFlag) {
      this.localappdata.userActions.showAllDataFlag = updatedFlag;
      if (this.storedDataAll.length > 0) {
        this.filterAndDisplayData();
      } else {
        this.populateVisibleList();
      }
    },
    updateSelectedMonths(updatedList) {
      this.localappdata.userActions.selectedMonths = updatedList;
      if (this.storedDataAll.length > 0) {
        this.filterAndDisplayData();
      } else {
        this.populateVisibleList();
      }
    },
    updateSelectedShip(updatedShip) {
      this.localappdata.userActions.selectedShip = updatedShip;
      if (this.storedDataAll.length > 0) {
        this.filterAndDisplayData();
      } else {
        this.populateVisibleList();
      }
    },
    populateVisibleList() {
      this.localappdata.isLoadingMore = true;

      setTimeout(() => {
        if (this.localappdata.dataAll && this.localappdata.dataAll.length > 0) {
          this.storedDataAll = [...this.localappdata.dataAll];
        }

        this.localappdata.isLoadingMore = false;
      }, 200);
    },

    // filter and display data based on stored data and selected filters
    filterAndDisplayData() {
      if (this.storedDataAll.length === 0) {
        return;
      }

      let visibleListArray = [];

      for (let i = 0; i < this.storedDataAll.length; i++) {
        let dealsAvailable = [];
        for (let a = 0; a < this.storedDataAll[i].categories.length; a++) {
          dealsAvailable.push(this.storedDataAll[i].categories[a].isAvailable);
        }

        const itemDirectionId = this.storedDataAll[i].directionId;
        const directionMatches = itemDirectionId == this.selectedDirectionId || !itemDirectionId;

        if (
          (this.localappdata.userActions.showAllDataFlag ||
            (!this.localappdata.userActions.showAllDataFlag &&
              dealsAvailable.toString().includes('true'))) &&
          (!this.localappdata.userActions.selectedMonths.length ||
            this.localappdata.userActions.selectedMonths.includes(
              this.storedDataAll[i].startMonth +
                ' ' +
                this.storedDataAll[i].startDateData.slice(0, 4)
            )) &&
          (!this.localappdata.userActions.selectedShip ||
            this.storedDataAll[i].shipNames.includes(this.localappdata.userActions.selectedShip) ||
            this.localappdata.userActions.selectedShip === 'all-ships') &&
          directionMatches
        ) {
          visibleListArray.push(this.storedDataAll[i]);
        }
      }

      this.localappdata.visibleList = visibleListArray;
    },
    toggleDropdownFilters() {
      const dropdownEls = $('.dropdown');
      dropdownEls.click(function (event) {
        event.stopPropagation();
        $(this).toggleClass('is-active');
        $(document).click(function () {
          dropdownEls.removeClass('is-active');
        });
      });
    },
    closeModal
  }
};
</script>
